import { ZfDialog, ZfDialogContent, ZfDialogFooter, ZfDialogHeader, ZfStack, ZfTextButton } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { ITranslation } from '../../interfaces/generic';
import { isValidTranslationFields } from '../../utils/form-utils';
import { MultiLanguageEditor } from '../atoms';

interface IProps {
    name: ITranslation;
    title: string;
    isOpen: boolean;
    onSave: (name: ITranslation) => void;
    onClose: () => void;
}

export const EditTopicNameModal: FunctionComponent<IProps> = ({ name: topicName, title, isOpen, onSave, onClose }) => {
    const { t } = useTranslation();
    const [name, setName] = useState<ITranslation>({ ...topicName });

    const saveTopicName = () => {
        onSave(name);
        onClose();
    };

    return (
        <ZfDialog show={isOpen} onDialogClose={onClose} size="small" position="center">
            <ZfDialogHeader>{title}</ZfDialogHeader>
            <ZfDialogContent>
                <MultiLanguageEditor value={name} onChange={setName} />
            </ZfDialogContent>
            <ZfDialogFooter>
                <ZfStack slot="primary" direction="row" spacing="extra-small">
                    <ZfTextButton size="medium" hierarchy="tertiary" onClick={onClose}>
                        {t('modalCloseButton')}
                    </ZfTextButton>
                    <ZfTextButton size="medium" hierarchy="primary" onClick={saveTopicName} disabled={!isValidTranslationFields(name)}>
                        {t('modalSaveButton')}
                    </ZfTextButton>
                </ZfStack>
            </ZfDialogFooter>
        </ZfDialog>
    );
};
